import React, { useRef } from 'react';
import ListPropertyLanding from '../ListPropertyLanding';
import ListPropertyForm from '../ListPropertyForm';

const ListPropertyPage: React.FC = () => {
  const formRef = useRef<HTMLDivElement>(null);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <ListPropertyLanding onGetStartedClick={handleScrollToForm}>
        <div ref={formRef}>
          <ListPropertyForm />
        </div>
      </ListPropertyLanding>
    </div>
  );
};

export default ListPropertyPage;